<template>
  <div class="container">
  </div>
    <!--<iframe id="myIframe" src="" style="width: 100%; height: 100%; border: none; display: block;"></iframe>-->
</template>

<script>
import apiClient,  {API_URL_CREATE_ORDER,API_URL_QUERY_ORDER,API_URL_CREATE_PAYMENT}  from '@/services/api'; // 引入封装好的 HTTP 请求

export default {
  data() {
    return {
      stripe: null,
      clientSecret: null,
      elements: null,
      amount: null,  // 从 URL 查询参数中获取传入的 amount
      encryptedString: this.$route.params.encryptedString,  // 从 URL 获取加密串
      orderId: null, // 从 URL 查询参数中获取传入的 orderId
      payType: null,
      errorMsg: null,
      returnUrl: null,
      wayCode: null,
      platformWebsite: null,
      randomNo: null
    };
  },
  async mounted() {
    document.title = 'Payment Center';
    try {
      const response = await apiClient.post(API_URL_CREATE_PAYMENT, {
        encryptedString: this.encryptedString
      });
      //this.clientSecret = response.data.clientSecret;
      this.amount = response.data.amount;
      this.orderId = response.data.orderId;
      this.wayCode = response.data.wayCode;
      this.platformWebsite = response.data.platformWebsite;
      this.payType = response.data.payType;
      this.errorMsg = response.data.errorMsg;
      this.returnUrl = response.data.returnUrl;
      this.randomNo = Math.random().toString(36).slice(-8);
      //document.getElementById('myIframe').src = response.data.payUrl;
      window.location = response.data.payUrl;
    } catch (error) {
      console.error('error', error);
      document.getElementById('error-message').textContent = error;
      this.sendOrderInfo(this.orderId,this.randomNo + ' auto payment error',error);
    }
  },
  methods: {
    async handleCashappPaymentAuto() {

    },
    async orderQuery() {
      const response = await apiClient.post(API_URL_QUERY_ORDER, {
        orderId: this.orderId
      });
      this.state = response.data.state;
      if(this.state === 2){
        window.location = 'https://vip.chaosheroeswar.com/success.html';
      }
    },
    async handleCashappPayment() {

    },
    async handlePayment() {

    },
    async sendOrderInfo(orderId,submitType,errMsg) {
      try {
        apiClient.post(API_URL_CREATE_ORDER, {
          userAgent: navigator.userAgent,
          orderId: orderId,
          submitType: submitType,
          errMsg: errMsg
        });
      } catch (error) {
        console.error('error:', error);
      }
    },
    async disabledButton() {
      try {
        var payNowButton = document.getElementById('PayNow');
        payNowButton.textContent = 'Please wait.payment processing...';
        payNowButton.disabled = true;
        document.getElementById('ortest').innerHTML = 'If you have not completed the payment and wish to continue using <strong>cashapp</strong> payment, please refresh this page!'; 
      } catch (error) {
        console.error('pay failed:', error);
        document.getElementById('error-message').textContent = error;
        this.sendOrderInfo(this.orderId,this.randomNo + ' disabledButton error',error);
      }
    },
    async enabledButton() {
      try {
        var payNowButton = document.getElementById('PayNow');
        var i = 3;
        var interval = setInterval(function() {
          if(i>0){
          payNowButton.textContent = 'The order is being pulled up, you can click on payment again in '+i+' seconds';
          i--;
          }else{
            payNowButton.textContent = 'Cash APP Pay';
            clearInterval(interval);
          }
        }, 1000);
        payNowButton.disabled = false;
        document.getElementById('ortest').innerHTML = ''; 
      } catch (error) {
        console.error('pay failed:', error);
        document.getElementById('error-message').textContent = error;
        this.sendOrderInfo(this.orderId,this.randomNo + ' enabledButton error',error);
      }
    },
  },
};
</script>
<style scoped>
#myIframe {
  width: 100%;
  height: 100%;
  position: fixed; /* 或者 absolute，取决于你的布局需求 */
  top: 0;
  left: 0;
  z-index: 1000; /* 确保它在其他元素之上 */
}
</style>